import { Link, Navigate, useLocation } from 'react-router-dom';

import { ROUTES } from 'Constants';
import { RegisterLocationState } from 'Models/_HumanWritten/LocationState';
import { SecuredGroups } from 'Models/Security/UserGroups';
import { themeStore } from 'Models/ThemeStore';
import LoginFlow from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/WizardSteps/LoginStep/LoginFlow';
import SecuredPage from 'Views/Components/Security/SecuredPage';
import { appConfigStore } from 'Models/AppConfigStore';
import useDeviceDetect from 'Hooks/useDeviceDetect';

export default function ConvertGuestPage() {
	const location = useLocation();
	const state = location.state as RegisterLocationState;
	const { isMobile } = useDeviceDetect();

	if (!appConfigStore.guestBookingsEnabled) {
		return <Navigate to={ROUTES.FERRY_SCHEDULE} replace />;
	}

	return (
		<div className="login-page">
			<Link className="logo-link" to="/home">
				<img
					src={isMobile ? themeStore.logoSecondaryLightURL : themeStore.logoPrimaryLightURL}
					alt="Company Logo"
				/>
			</Link>
			<div
				className="top-section"
				style={{
					backgroundImage: `url(${themeStore.loginBackgroundImageURL})`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
				}}
			/>
			<div className="bottom-section" />
			<div className="center-section">
				<LoginFlow mode="convertGuest" initialParams={state} />
			</div>
		</div>
	);
}
